/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class EventItem extends PureComponent {
  _goDetail = () => {
    const { history } = this.props;
    const { LinkURL, Linktarget } = this.props.childProps;

    if (Linktarget === '_self') {
      console.log(LinkURL);
      history.push(LinkURL);
    } else {
      window.open(LinkURL, '', '');
    }
  };
  _onNaver = () => {
    // const { colSerial } = this.state;
    const { idx, title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/event/' + idx;
    window.open(
      'http://share.naver.com/web/shareView.nhn?url=' +
        encodeURIComponent(url) +
        '&title=' +
        encodeURIComponent(title),
      'naversharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onTwitter = () => {
    const { idx, title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/event/' + idx;
    window.open(
      'https://twitter.com/intent/tweet?text=[%EA%B3%B5%EC%9C%A0]%20' +
        encodeURIComponent(url) +
        '%20-%20' +
        encodeURIComponent(title ? title : document.title),
      'twittersharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onFacebook = () => {
    const { idx, title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/event/' + idx;
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&t=' +
        encodeURIComponent(title ? title : document.title),
      'facebooksharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onInstar = () => {
    const { idx } = this.props.childProps;
    const url = 'http://www.aniplustv.com/event/' + idx;
    window.open(
      'https://plus.google.com/share?url=' + encodeURIComponent(url),
      'googleplussharedialog',
      'menubar=no,toolbar=no,resizable=yes, scrollbars=yes,height=350,width=600'
    );
  };
  _onKakao = () => {
    const { idx } = this.props.childProps;
    const url = 'http://www.aniplustv.com/event/' + idx;
    window.open(
      'https://story.kakao.com/s/share?url=' + encodeURIComponent(url),
      'kakaostorysharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes, height=400,width=600'
    );
  };
  render() {
    const { title, comment, banner, comment_count, openDay } =
      this.props.childProps;
    const { imgUrl } = this.props;
    let className;
    let store;
    if (title.indexOf('합정') > -1) {
      className = 'store_card su_hj';
      store = '합정점';
    } else if (title.indexOf('대전') > -1) {
      className = 'store_card dj_ja';
      store = '대전점';
    } else if (title.indexOf('광주') > -1) {
      className = 'store_card gj_cj';
      store = '광주점';
    } else if (title.indexOf('부산') > -1) {
      className = 'store_card bs_sm';
      store = '부산점';
    } else {
      className = 'store_card et_et';
      store = '전 지점';
    }
    //console.log(banner)
    //console.log(bannerFile)
    return (
      <Fragment>
        <div className={className}>
          {/* 카드 상단/ */}
          <div className="store_card_top">
            <span className="tag">[{store}] 이벤트</span>
            <ul className="store_card_top_rt">
              {/*<li className="store_card_ico">
                                    <span className="ico_like"></span>
                                    <span className="num">0</span>
                                </li>*/}
              <li className="store_card_ico">
                <span className="ico_reply"></span>
                <span className="num">{comment_count}</span>
              </li>
              <li className="store_card_ico btn_more">
                <span className="ico_more"></span>
                <ul className="more_wrap">
                  <li>
                    <a onClick={this._onFacebook} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_fb.png'}
                        alt="페이스북"
                      />
                    </a>
                  </li>
                  <li>
                    <a onClick={this._onKakao} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_kako.png'}
                        alt="카카오"
                      />
                    </a>
                  </li>
                  <li>
                    <a onClick={this._onInstar} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_google.png'}
                        alt="구글"
                      />
                    </a>
                  </li>
                  <li>
                    <a onClick={this._onTwitter} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_twt.png'}
                        alt="트위터"
                      />
                    </a>
                  </li>
                  <li>
                    <a onClick={this._onNaver} style={{ cursor: 'pointer' }}>
                      <img
                        src={imgUrl + '/img/store/sns_naver.png'}
                        alt="네이버"
                      />
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          {/* 카드 타이틀/ */}
          <div className="store_card_tit">
            <p className="date">
              <span>{openDay}</span>
            </p>
            <p className="tit" onClick={this._goDetail}>
              {title}
            </p>
            <p className="summary" onClick={this._goDetail}>
              {comment}
            </p>
          </div>
          {/* 카드 썸네일/ */}
          {banner === '' || banner === undefined || banner === null ? null : (
            <div className="store_card_thumb" onClick={this._goDetail}>
              <img src={banner} />
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(React.memo(EventItem)));
